<!-- <div><h4>Post Your Job</h4></div> -->
<form
  name="form"
  (ngSubmit)="f.form.valid && processData()"
  #f="ngForm"
  novalidate
>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group padding-right-10">
        <!-- ABOUT US: TEAM -->
        <mat-form-field>
          <mat-select
            placeholder="Select Team"
            [(ngModel)]="MemberData.subSectionName"
            name="team"
            #team="ngModel"
            required
          >
            <mat-option
              *ngFor="let team of Teams"
              [value]="team?.subSectionName"
            >
              {{ team?.subSectionName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-6" *ngIf="MemberData.subSectionName !== 'Our Sponsors'">
      <div class="form-group">
        <!-- CAREER:JOB TITLE-->
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Position "
            [(ngModel)]="MemberData.position"
            name="position"
            #position="ngModel"
            required
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group padding-right-10">
        <!-- CAREER: DEPARTMENT -->
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Name"
            [(ngModel)]="MemberData.title"
            name="title"
            #title="ngModel"
            required
          />
        </mat-form-field>
       
      </div>
    </div>
    <div class="col-md-6" >
      <div class="form-group">
        <!-- CAREER:JOB TITLE-->
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Display Order "
            [(ngModel)]="MemberData.orderOfDisplay"
            name="orderOfDisplay"
            #orderOfDisplay="ngModel"
            (keypress)="allowOnlyNumbers($event)"
            required
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- CAREER:JOB DISCRIPTION -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <div class="align-h margin-bottom-10">
          <h5 class="margin-bottom-0">Member profile</h5>
          <span>(description)</span>
        </div>
        <angular-editor
          [placeholder]
          [(ngModel)]="MemberData.description"
          name="description"
          #description="ngModel"
          required
          [config]="editorConfig"
        ></angular-editor>
      </div>
    </div>
  </div>
  


    <div class="col-md-12" *ngIf="MemberData.subSectionName !== 'Our Sponsors'">
      <div class="form-group padding-right-10">
        <app-file-input
          *ngIf="!MemberData.imageUrl"
          (fileChange)="onFileChange($event)"
          [(ngModel)]="fileName"
          name="fileName"
          placeholder="Upload Image"
          required
        >
          <button type="button" mat-raised-button color="primary">
            Choose
          </button>
        </app-file-input>
        <ng-template [ngIf]="MemberData.imageUrl">
          <mat-form-field>
            <input
              disabled
              matInput
              placeholder="Image"
              [(ngModel)]="MemberData.imageUrl"
              name="Image"
            />
            <button
              class="margin-right-30"
              mat-button
              matSuffix
              mat-icon-button
              type="button"
              (click)="MemberData.imageUrl = ''"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
      </div>
    </div>

  <div class="margin-top-20 text-center">
    <button
      mat-raised-button
      color="primary"
      class="mat-button-large"
      type="submit"
      [disabled]="!f.valid"
    >
      <span *ngIf="!MemberData.id">Submit</span>
      <span *ngIf="MemberData.id">Update</span>
    </button>
  </div>
</form>

